import * as React from 'react'
import StepLabel from '@mui/material/StepLabel'
import StepContent from '@mui/material/StepContent'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import { Box } from '@mui/material'
import { CustomStepIcon } from './CustomStepIcon'
import { useTranslation } from 'react-i18next'
import { IStep } from './types.d'

interface InjectedProps {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>
  index: number
  handleClose: () => void
  refetch: () => void
  completed: boolean
}

export type SetupWizardStepComponent = React.FC<InjectedProps>

export const SetupWizardStep: React.FC<InjectedProps & { step: IStep }> = ({ completed, step, setActiveStep, index, handleClose }) => {
  const { t } = useTranslation()

  return (
    <>
      <StepLabel
        StepIconComponent={props => <CustomStepIcon {...props} icon={step.icon} />}
        StepIconProps={{
          sx: {
            fontSize: '20px'
          }
        }}
        onClick={() => setActiveStep(index)}
        sx={{
          cursor: 'pointer',
          color: 'info.dark'
        }}
      >
        {step.buttonText}
      </StepLabel>
      <StepContent>
        <Typography>{step.content}</Typography>
        <Box sx={{ mb: 2 }}>
          <Tooltip followCursor open={completed} title={<>{t('SetupWizard.finishedStep')}</>}>
            <div>
              <Button
                variant='contained'
                onClick={() => {
                  step.actionOnClick()
                  handleClose()
                }}
                fullWidth
                disabled={completed}
                sx={{ mt: 1, mr: 1 }}
              >
                {step.buttonText}
              </Button>
            </div>
          </Tooltip>
          {step.skipAction && (
            <Button variant='text' disabled={completed} fullWidth onClick={step.skipAction}>
              {t('SetupWizard.skip')}
            </Button>
          )}
        </Box>
      </StepContent>
    </>
  )
}
